import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const ResidentLink = styled(Link)(({ theme }) => ({
  '&:focus-visible': {
    borderRadius: theme.border.radius['4'],
    outline: `${theme.border.size['2']} solid ${theme.colors.blue500}`,
  },
  '&:hover': {
    color: theme.colors.blue500,
    textDecorationColor: theme.colors.blue500,
  },
  color: theme.colors.black800,
  cursor: 'pointer',
  textDecoration: 'underline',
  textDecorationColor: theme.colors.black300,
  textDecorationThickness: theme.border.size['1'],
  textUnderlineOffset: '0.25rem',
  transition: `color ${theme.transition.duration.sm} ease, text-decoration-color ${theme.transition.duration.sm} ease`,
}))
